import { render, staticRenderFns } from "./_cart_modal.vue?vue&type=template&id=ed384848&"
import script from "./_cart_modal.vue?vue&type=script&lang=js&"
export * from "./_cart_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports